import { useCallback, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { ReservationService } from "../../../services";
import useCommonClasses from '../../../styles/common'
import snackbarUtils from "../../../utils/snackbarUtils";
import { formatError } from "../../../utils/formatters";

interface Props {
  reservationId: number;
  isOpen: boolean;
  handleClose: () => void;
}

const CancelScheduleDialog = (props: Props) => {
  const classes = useStyles();
  const commonClasses = useCommonClasses();
  const { reservationId, isOpen, handleClose } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCancel = useCallback(async (reservation_id: number) => {
    setIsSubmitting(true);
    try {
      await ReservationService.cancelReservation(reservation_id);
      if (isOpen) handleClose();
    } catch (error) {
      console.error(error.message);
      snackbarUtils.error(formatError(error));
    } finally {
      setIsSubmitting(false);
    }
  }, [handleClose, isOpen]);

  return (
    <Dialog
      aria-labelledby="dialogo-de-cancelamento-de-agendamento"
      onClose={handleClose}
      open={isOpen}
      className={classes.dialog}
    >
      <DialogTitle>
        Deseja cancelar seu agendamento?
        <Typography>Esta ação não poderá ser revertida.</Typography>
      </DialogTitle>
      <DialogActions className={classes.buttonsContainer}>
        <Button
          variant="contained"
          disableElevation
          onClick={handleClose}
          className={classes.cancelButton}
        >
          Não, voltar!
        </Button>
        <Button
          data-cy="cancel-appointment-button"
          variant="outlined"
          onClick={() => handleCancel(reservationId)}
          startIcon={isSubmitting ? <CircularProgress size="1rem" /> : null}
          disabled={isSubmitting}
          className={commonClasses.outlinedButton}
        >
          Sim, eu quero cancelar.
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelScheduleDialog;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialog: {
      padding: theme.spacing(4),
      borderRadius: 25,

      '& h2': {
        color: theme.palette.error.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center',
        textTransform: 'initial',
      },

      '& p': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.pxToRem(16),
      }
    },

    buttonsContainer: {
      marginTop: theme.spacing(4),
    },
    cancelButton: {
      color: theme.palette.primary.contrastText,
      textTransform: 'initial',
      background: theme.palette.error.main,
      borderRadius: 17,
    }
  })
);